export interface VideoPreviewProps {
    src: string;
    className?: string;
}
export const VideoPreview = ({ src, className }: VideoPreviewProps) => {
    return (
        <video loop={true} playsInline={true} preload="auto" autoPlay={true} className={className || ''}>
            <source src={src} />
        </video>
    )
}